import { buildLangUrl } from '@fs/zion-router'
import axios from 'axios'

/**
 * Triggers the download of a file in the browser.
 *
 * @param {Blob} blob - The file data as a Blob object.
 * @param {string} filename - The name of the file to be downloaded.
 */
export const triggerFileDownload = (blob, filename) => {
  const url = URL.createObjectURL(blob)
  const linkElement = Object.assign(document.createElement('a'), {
    href: url,
    download: filename,
  })

  // Simulate the click to start download
  linkElement.click()

  // Clean up the object URL (important to avoid memory leaks)
  URL.revokeObjectURL(url)
}

/**
 * Generates a PDF Blob from the provided content, image URL, highlights, and URL.
 *
 * @async
 * @function
 * @param {Object} params - The parameters for generating the PDF Blob.
 * @param {string} params.content - The textual content to include in the PDF.
 * @param {string} params.imageUrl - The URL of the image to include in the PDF.
 * @param {Array} params.highlights - An array of highlights to include in the PDF.
 * @param {string} params.url - The URL associated with the PDF generation.
 * @returns {Promise<Blob>} A promise that resolves to a Blob representing the generated PDF.
 */
export const generatePdfBlob = async ({ content, imageUrl, highlights, url }) => {
  const isLocalhost = window.location.hostname === 'localhost'
  const downloadUrl = isLocalhost ? `/en/records/improve/fullTextPdf` : buildLangUrl('/records/improve/fullTextPdf')

  const response = await axios.post(
    downloadUrl,
    { transcript: content, src: imageUrl, highlights, url },
    {
      headers: { Accept: 'application/octet-stream' },
      responseType: 'arraybuffer',
    }
  )

  return new Blob([response.data], { type: 'application/pdf' })
}
